package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.mouseOverColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.scale

import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms

val Scale_Selected_ItemStyle = CssStyle {

    base {
        Modifier
//            .fontSize(16.px)
            .scale(1)
//            .rotate(45f)
            .color(unselectedColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
    }
    hover {
        Modifier
            .scale(1.15)
//            .fontSize(22.px)
            .color(mouseOverColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
    }

}

val Scale_Rotate_Selected_ItemStyle = CssStyle {

    base {
        Modifier
            .scale(1)
            .color(unselectedColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
    }
    hover {
        Modifier
            .scale(1.1)
            .rotate(25.deg)
            .color(mouseOverColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
    }

}

val Selected_ItemStyle = CssStyle {

    base {
        Modifier
            .color(unselectedColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
    }
    hover {
        Modifier

            .color(mouseOverColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
    }

}
